<template>
	<row>
		<container>
			<div class="text-center mb-16">
				<h2
					class="gradient-title-white text-[50px] lg:text-[54px] font-medium text-center"
				>
					Enough About Us&nbsp;—&nbsp;
				</h2>
				<h2
					class="gradient-title-white text-[50px] lg:text-[54px] font-medium text-center"
				>
					Here’s What We Deliver
				</h2>
				<p class="text-slate-100 text-lg font-normal leading-[27px] mt-6">
					StocksToTrade is different from any other platform available on the market
					today... Our state-of-the-art platform was developed by traders, for
					traders — with high-frequency day traders at the top of mind.
				</p>
			</div>

			<div class="hidden lg:block">
				<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					<FeatureCard2
						v-for="(feature, index) in features.slice(0, 3)"
						:key="index"
						:title="feature.title"
						:icon="feature.icon"
						:description="feature.description"
					/>
				</div>

				<div
					class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 mt-8 lg:mt-8"
				>
					<FeatureCard2
						v-for="(feature, index) in features.slice(3)"
						:key="index"
						:title="feature.title"
						:icon="feature.icon"
						:description="feature.description"
					/>
				</div>
			</div>
			<div class="block lg:hidden">
				<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					<FeatureCard2
						v-for="(feature, index) in features"
						:key="index"
						:title="feature.title"
						:icon="feature.icon"
						:description="feature.description"
					/>
				</div>
			</div>
		</container>
	</row>
</template>

<script setup>
const features = [
	{
		title: "We understand that finding and executing trades is all about speed",
		icon: "/images/feature-icons/wfeature-icon-4.svg",
		description:
			"You don’t have time to sift through multiple websites, apps, or software to find trade opportunities and news. You want to uncover the next big gainer, find news, spot key levels, plan your trade, and execute."
	},
	{
		title: "We’re here to help you do all that as quickly as possible",
		icon: "/images/feature-icons/afeature-icon-3.svg",
		description:
			"That’s why we developed all our features and tools like built-in watchlists, scans, and two proprietary algorithms to help you spot hot trade opportunities FAST."
	},
	{
		title: "We’re help you spot key levels to make planning a trade a breeze",
		icon: "/images/feature-icons/wfeature-icon-1.svg",
		description:
			"Our powerful charting tools and exclusive indicators help you spot key levels to make planning a trade a breeze."
	},
	{
		title:
			"Add-on features like our Breaking News and Small-Cap Rockets chat rooms",
		icon: "/images/feature-icons/afeature-icon-2.svg",
		description:
			"We also offer add-on features like our Breaking News and Small-Cap Rockets chat rooms so you get news, information, and trade ideas from a variety of perspectives."
	},
	{
		title: "Combine all our tools with training and alerts from elite traders",
		icon: "/images/feature-icons/afeature-icon-1.svg",
		description:
			"We’re combining all our tools with training and alerts from our elite levels trainers and you have everything you need to start spotting and executing YOUR best trades!"
	}
];
</script>

<style lang="scss" scoped>
div {
}
</style>
